import { apiAgent } from "../../config/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateLoadError, setSavingState } from "./testSuiteScenarioSlice";

const attachScenariosWithSuites = createAsyncThunk(
  "attachScenariosWithSuites",
  async ({ testSuiteId, testScenarioIds }, { dispatch }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_suite_scenarios/attach",
        data: {
          test_suite_id: testSuiteId,
          test_scenario_ids: testScenarioIds,
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const detachScenarioFromSuite = createAsyncThunk(
  "detachScenarioFromSuite",
  async ({ testScenarioId, testSuiteId }, { dispatch }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_suite_scenarios/detach",
        data: {
          test_scenario_id: testScenarioId,
          test_suite_id: testSuiteId,
        },
      });
      if (response.status === 204) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const fetchExistingPreRequisiteWithSuites = createAsyncThunk(
  "fetchExistingPreRequisiteWithSuites",
  async ({ testSuiteId }, { dispatch }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "GET",
        url: "/api/v1/test_suite_prerequisites",
        params: {
          test_suite_id: testSuiteId
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const attachPreRequisiteWithSuites = createAsyncThunk(
  "attachPreRequisiteWithSuites",
  async ({ testSuiteId, testScenarioIds }, { dispatch }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_suite_prerequisites/attach",
        data: {
          test_suite_id: testSuiteId,
          test_scenario_ids: testScenarioIds,
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

const detachPreRequisiteFromSuite = createAsyncThunk(
  "detachPreRequisiteFromSuite",
  async ({ testScenarioId, testSuiteId }, { dispatch }) => {
    await dispatch(setSavingState(true));
    try {
      const response = await apiAgent({
        method: "POST",
        url: "/api/v1/test_suite_prerequisites/detach",
        data: {
          test_scenario_id: testScenarioId,
          test_suite_id: testSuiteId,
        },
      });
      if (response.status === 200) {
        await dispatch(setSavingState(false));
        return response?.data;
      }
    } catch (err) {
      dispatch(updateLoadError({ error_message: err.response.data.message }));
    }
  }
);

export {
  attachScenariosWithSuites,
  detachScenarioFromSuite,
  attachPreRequisiteWithSuites,
  detachPreRequisiteFromSuite,
  fetchExistingPreRequisiteWithSuites
};
